<section class="lead-hero curve -bottom -white">
    <span class="photo"></span>
    <div class="intro">
        <div class="container">
            <div class="flow">
                <a [routerLink]="['/home']">
                    <i class="icon icon-arrow-back"></i>
                    <span class="text">{{language.back}}</span>
                </a>
            </div>
            <h1 class="title">{{language.step3header}}</h1>
        </div>
    </div>
</section>
<section *ngIf="!sentEmailComplete" class="section section-form curve -top -white">
    <div class="container">
        <form accept-charset="utf-8" class="form form-horizontal -calculate -confirm">
            <fieldset class="personal">
                <legend class="text-center">
                    <h2 class="topic-title">
                        {{language.step3topic1}}
                        <br> {{language.step3topic2}}
                    </h2>
                </legend>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label class="col-md-5 col-lg-4 control-label">* {{language.step3info1}} </label>
                            <div class="col-md-7 col-lg-7 col-xl-7">
                                <input [(ngModel)]="fName" [ngClass]="{require: fNameRequire}" class="form-control" type="text" maxlength="400" [ngModelOptions]="{standalone: true}" />
                                <div *ngIf="fNameRequire" class="error-message">{{language.step3error1}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label class="col-md-5 col-lg-4 control-label">{{language.step3info2}}</label>
                            <div class="col-md-7 col-lg-7 col-xl-7">
                                <input [(ngModel)]="lName" class="form-control" type="text" maxlength="400" [ngModelOptions]="{standalone: true}" />
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label class="col-md-5 col-lg-4 control-label">* {{language.step3info3}}</label>
                            <div class="col-md-7 col-lg-7 col-xl-7">
                                <input [(ngModel)]="tel" required type="tel" name="Tel" [ngClass]="{require: telRequire}" class="form-control" type="text" maxlength="400" [ngModelOptions]="{standalone: true}" />
                                <div *ngIf="telRequire" class="error-message">{{language.step3error2}}</div>
                                <div *ngIf="telInvalidPattern" class="error-message">{{language.step3error3}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label class="col-md-5 col-lg-4 control-label">{{language.step3info4}}</label>
                            <div class="col-md-7 col-lg-7 col-xl-7">
                                <input [(ngModel)]="email" [textMask]="{mask: emailPattern}" placeholder="___@___.___" required type="text" name="Email" class="form-control" type="text" maxlength="400" [ngModelOptions]="{standalone: true}" />
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
            <footer class="footer-button -two">
                <a [routerLink]="['/calculate/step2']" class="btn btn-primary -brand -short -bg-white">{{language.step3backbtn}}</a>
                <button class="btn btn-primary -brand -short" type="button" (click)="submit()">
          <span class="text-center">{{language.step3comfirmbtn}}</span>
        </button>
            </footer>
        </form>
    </div>
</section>

<section *ngIf="sentEmailComplete" id="empty-wrapper" class="section section--empty">
    <div class="container">
        <div class="wrapper">
            <header>
                <span class="icon" rel="border-circle">
          <i class="icon icon-email"></i>
        </span>
                <h1 class="title">{{language.step3msg1}}</h1>
            </header>
            <p>{{language.step3msg2}}
                <br> {{language.step3msg3}}
            </p>
            <footer>
                <a [routerLink]="['/home']" class="btn btn-primary -brand">{{language.back}}</a>
            </footer>
        </div>
    </div>
</section>

<ngx-ui-loader></ngx-ui-loader>